import { Avatar } from "@material-ui/core";
import styled from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  position: fixed;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  background-color: var(--slack-color);
  color: white;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  margin-left: 20px;
  flex: 0.17;

  > svg {
    margin-left: auto;
    margin-right: 30px;
  }
`;

export const HeaderAvatar = styled(Avatar)`
  cursor: pointer;
  margin: 0 10px;
  :hover {
    opacity: 0.8;
  }

  @media (min-width: 1000px) {
    margin: 0;
  }
`;

export const HeaderSearch = styled.div`
  background-color: #421f44;
  border: 1px solid white;
  border-radius: 6px;
  color: gray;
  display: flex;
  opacity: 1;
  margin-right: 10px;
  min-width: 25vw;

  > input {
    background-color: transparent;
    border: none;
    color: white;
    outline: none;
  }

  > svg {
    margin-right: 20px;
  }

  @media (min-width: 1000px) {
    flex: 0.3;
    padding: 0 50px;
    margin-right: 0;

    > input {
      text-align: center;
    }

    > svg {
      margin-right: 0;
    }
  }
`;

export const HeaderRight = styled.div`
  flex: 0.1;
  display: flex;
  align-items: center;
  justify-content: space-around;

  > svg {
    margin-left: auto;
    margin-right: 20px;
  }
`;
